import { PlanProductEntry } from './types';

// The "None" option is stored as the literal key 'none', but means "match
// products with no value" — the empty string, not the literal word.
export const resolveFilterValue = (key: string | null): string | null =>
  key === 'none' ? '' : key;

/**
 * Applies the Timing and Timing Tag filters together (a product must match
 * whichever ones are active), rather than each filter independently
 * overwriting every product's `hide` from only its own value — otherwise
 * selecting or clearing one filter would wipe out the other filter's effect.
 */
export const computeProductVisibility = (
  products: PlanProductEntry[],
  timingKey: string | null,
  timingTagKey: string | null
): PlanProductEntry[] => {
  const timingValue = resolveFilterValue(timingKey);
  const timingTagValue = resolveFilterValue(timingTagKey);

  return products.map(prod => ({
    ...prod,
    hide:
      (timingValue != null && timingValue !== prod.timingEvent) ||
      (timingTagValue != null && timingTagValue !== prod.timingEventTag)
  }));
};
